import { Box, Divider, Typography } from '@mui/material';
import { rootSx } from './style';

export default function UnSupervisedGuideContent() {
  return (
    <Box className="UnSupervisedGuideContent-root" sx={rootSx}>
      <Box className="UnSupervisedGuideContent-main">
        <Typography className="UnSupervisedGuideContent-title">비지도학습 설명</Typography>
        <Typography className="UnSupervisedGuideContent-subtitle">
          새로운 데이터의 규칙성을 찾는 방법
        </Typography>
      </Box>

      <Box className="UnSupervisedGuideContent-section">
        <Box className="UnSupervisedGuideContent-imageBox">
          <img src="/_static/images/unsupervised_1.png" width="100%" alt="" />
        </Box>
        <Typography>
          <b>비지도 학습(Unsupervised Learning)</b>은 지도 학습과는 달리 정답을 알려주지 않고,
          비슷한 데이터의 패턴을 스스로 파악하여 새로운 데이터의 규칙성을 찾는 방법입니다. <br />
        </Typography>
      </Box>

      <Divider />
      <Box className="UnSupervisedGuideContent-section">
        <Box className="UnSupervisedGuideContent-title">데이터셋</Box>
        <Typography>
          <em>데이터셋</em>이란 컴퓨터가 스스로 패턴이나 구조를 찾을 수 있도록 제공하는 데이터
          모음입니다.
          <br />
          비지도 학습에서의 데이터 셋은 데이터가 어떤 그룹에 속하는지, 또는 특정한 결과가 무엇인지
          미리 알려주지 않습니다.
          <br />
          대신, 데이터셋은 여러 개의 항목(예: 사탕, 이미지, 문서 등)으로 구성되어 있으며, 이
          항목들은 다양한 특성(예: 색깔, 크기, 모양 등)을 가지고 있습니다.
          <br />
          <br />
          비지도 학습의 알고리즘은 이 데이터셋을 분석하면서 비슷한 특성을 가진 항목들을 그룹으로
          묶거나, 데이터 내의 숨겨진 패턴을 찾으려고 합니다.
          <br />이 과정을 통해 컴퓨터는 데이터의 구조를 이해하고, 이를 바탕으로 스스로 분석하고
          결과를 도출합니다.
          <Box className="UnSupervisedGuideContent-imageBox">
            <img src="/_static/images/unsupervised_2.png" width={300} alt="" />
          </Box>
        </Typography>
        <Box className="UnSupervisedGuideContent-subtitle">군집화</Box>
        <Typography>
          <em>군집화(Clustering)</em>는 자동으로 데이터를 비슷한 것끼리 그룹으로 나누는 방법입니다.
          <br />
          예를 들어, 다양한 색깔과 모양의 사탕이 있다고 했을때, 군집화를 통해 이 사탕들을 스스로
          비슷한 색깔이나 모양에 따라 그룹으로 나눠줍니다.
          <br />이 과정에는 미리 정해진 정답이 없어서, 컴퓨터는 스스로 각 사탕의 색깔, 크기, 모양
          등을 보고, 비슷한 특성을 가진 사탕들을 찾아서 같은 그룹으로 만들어줍니다.
          <Box className="UnSupervisedGuideContent-imageBox">
            <img src="/_static/images/unsupervised_3.png" width={300} alt="" />
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
